import React from "react";
import { NumberField } from "@shoptet/ui";
import { formatCurrencyUnit } from "../i18n/formatNumbers";

interface CurrencyInputProps {
  currency?: string;
  error?: boolean;
  errorText?: string;
  label: string;
  name: string;
  onChange: (value: string) => void;
  value: string;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  currency,
  error = false,
  errorText,
  label,
  name,
  onChange,
  value,
}) => {
  const handleChange = (newValue: number | null) => {
    if (newValue === null || newValue < 0) {
      onChange("");
      return;
    }

    onChange(newValue.toString());
  };

  return (
    <div className="currencyInput">
      <div style={{ display: "flex", alignItems: "center" }}>
        <NumberField
          error={error}
          label={label}
          min={0}
          name={name}
          value={value === "" ? null : parseFloat(value)}
          width="full"
          labelHidden
          onChange={handleChange}
        />
        {currency && <p style={{ margin: "0 0 0 8px" }}>{formatCurrencyUnit(currency)}</p>}
      </div>
      {errorText && error && <p style={{ color: "var(--app-critical)", margin: "4px 0 0 0" }}>{errorText}</p>}
    </div>
  );
};

export default CurrencyInput;
